import { DocumentGenerateForm } from '../components/DocumentGenerateForm';

export function GeneratePage() {
  return <DocumentGenerateForm />;
}
